/**
 * Billing Cancel Page
 *
 * Where Stripe sends users if they leave Checkout without paying.
 */

import { Link } from 'react-router-dom'

const NAVY = '#0A1F44'
const BLUE = '#1E5BD6'

export default function BillingCancel() {
  return (
    <div style={{ maxWidth: 520, margin: '80px auto', textAlign: 'center', padding: 24 }}>
      <h1 style={{ color: NAVY, fontSize: 28, marginBottom: 12 }}>No worries</h1>
      <p style={{ color: '#445', fontSize: 16, lineHeight: 1.5 }}>
        Your card wasn't charged. You can subscribe any time.
      </p>
      <Link
        to="/chat"
        style={{
          display: 'inline-block', marginTop: 24, background: BLUE, color: '#fff',
          textDecoration: 'none', borderRadius: 10, padding: '12px 22px', fontWeight: 600,
        }}
      >
        Back to JAI
      </Link>
    </div>
  )
}
